import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterIssueNodeClick } from "@faire/web-api/events/helpCenter/click/issueNode";
import { useEffect } from "react";
import { useAsyncDataStatus } from "./useAsyncDataStatus";
/**
 * Calls the async functions to fetch the additional data required by the pete event;
 * The PETE event data is fired when the user clicks on a node.
 */
export var usePeteEventAdditionalDataEffect = function usePeteEventAdditionalDataEffect(context, node) {
  var _useAsyncDataStatus = useAsyncDataStatus(),
    asyncDataInProgress = _useAsyncDataStatus.asyncDataInProgress,
    asyncDataComplete = _useAsyncDataStatus.asyncDataComplete,
    setAsInProgress = _useAsyncDataStatus.setAsInProgress,
    setAsComplete = _useAsyncDataStatus.setAsComplete,
    setAsNotRequestedYet = _useAsyncDataStatus.setAsNotRequestedYet;
  useEffect(function () {
    setAsNotRequestedYet();
  }, [node, setAsNotRequestedYet]);
  useEffect(function () {
    if (asyncDataInProgress || asyncDataComplete) {
      return;
    }
    if (!node) {
      setAsComplete();
      return;
    }
    if (!node.additionalPeteEventData) {
      emitPeteEvent("", node);
      setAsComplete();
      return;
    }
    setAsInProgress();
    invokeAdditionalDataFn(node, context).then(function (data) {
      emitPeteEvent(data, node);
    }).then(setAsComplete);
  }, [asyncDataComplete, asyncDataInProgress, context, node, setAsComplete, setAsInProgress]);
};
var emitPeteEvent = function emitPeteEvent(peteEventData, node) {
  var _getBrandToken, _getRetailerToken;
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  trackHelpCenterIssueNodeClick(brandToken, retailerToken, peteEventData, node.id);
};
var invokeAdditionalDataFn = function invokeAdditionalDataFn(node, context) {
  if (!node.additionalPeteEventData) {
    return Promise.resolve("");
  }
  return node.additionalPeteEventData(context);
};